/**
 * Format API endpoint URL
 * @param routePrefix
 * @param path
 */
export const formatApiUrl = (routePrefix: string, path: string | number = ''): string => {
    return path ? `${routePrefix}/${path}` : `${routePrefix}`;
};
